module.exports = __webpack_public_path__ + "static/media/imgMarketing03.99357dd3.png";